import { DIALOGS } from '@/store/dialogs/dialogs.constants'
import { DialogsStoreState } from '@/store/dialogs/dialogs.types'

export const getDefaultState = () => {
  const state: DialogsStoreState = {
    dialogs: {} as DialogsStoreState['dialogs'],
  }

  for (const key in DIALOGS) {
    const dialog = DIALOGS[key as keyof typeof DIALOGS]

    state.dialogs[dialog] = {
      visible: false,
      props: null,
    }
  }

  return state
}
